{
  "name": "toplist",
  "version": "0.0.0",
  "author": "",
  "license": "ISC",
  "description": "",
  "dependencies": {
    "js-levenshtein": "^1.1.6",
    "linkify-string": "^4.1.3",
    "linkifyjs": "^4.1.3",
    "lit-html": "^3.1.4",
    "parcel": "^2.16.4",
    "qrcode-svg": "^1.1.0",
    "unique-names-generator": "^4.7.1"
  },
  "devDependencies": {
    "@parcel/packager-raw-url": "^2.16.4",
    "@parcel/transformer-webmanifest": "^2.16.4",
    "pre-commit": "^1.2.2"
  },
  "scripts": {
    "test": "echo \"Error: no test specified\" && exit 1",
    "fmt-check": "npx prettier -c *.{mjs,html,css,yml}",
    "fmt": "npm run fmt-check -- -w",
    "build": "parcel build --public-url /toplist",
    "serve": "parcel serve"
  },
  "targets": {
    "default": {
      "source": [
        "./index.html"
      ]
    }
  },
  "pre-commit": [
    "fmt-check"
  ]
}
